export const FirebaseInsurancesKey = "insurances";
export const FirebaseBalanceRequestsKey = "balance-requests";
export const NotificationsFirebaseKey = "notifications";
export const FirebaseRequestsKey = "requests";
